exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/** Colors */\n/** FlatUI Color Palette\n*\n*\tColor names based on FlatUI: https://flatuicolors.com/\n*/\n/** Acrylic Color Palette\n*\n*\tColor names based on Name that Color: http://chir.ag/projects/name-that-color\n*/\n.InputLabel-primary {\n  background-color: #0067cb;\n  color: white;\n  width: 100px;\n  max-width: 100px;\n  min-width: 100px; }\n\n.InputLabel-default {\n  width: 100px;\n  max-width: 100px;\n  min-width: 100px; }\n\n.closebtn {\n  padding-left: 10px;\n  color: #888;\n  font-weight: bold;\n  float: right;\n  font-size: 20px;\n  cursor: pointer; }\n\n.closebtn:hover {\n  color: #000; }\n", ""]);

// exports
